export default function stateHasError(slice: any) {
  return (state: any) => {
    return state.getIn([slice, 'meta', 'status']) === 'error';
  };
}
